import { MutableRefObject, createContext } from "react";

export interface OrderContextData {
	orderId?: string;
	leftTipValue: MutableRefObject<number>;
	currency: string;
	alreadyGivenTip?: number;
}

export const OrderContext = createContext<OrderContextData>({
	leftTipValue: { current: 5 },
	currency: "PLN",
});
